import { Dispatcher } from '@/APIDispatcher'
import {vm} from '@/main'

export const ExchangeApi = {

  list () {
    return new Promise((resolve, reject) => {
      let promise = Dispatcher.post('exchanges/list', {}).then(s => {
        if (Dispatcher.success(s)) {
          resolve(s.exchanges)
        } else {
          vm.$notify.error('List Failed', 'Exchange name list failed: ' + s.errorCode)
          reject(new Error(s.errorCode))
        }
      })
    })
  },
  details (companyId) {
    return new Promise((resolve, reject) => {
      let promise = Dispatcher.post('exchange/details', { company_id: companyId }).then(s => {
        if (Dispatcher.success(s)) {
          resolve(s.details)
        } else {
          reject(new Error(s.errorCode))
        }
      })
    })
  },
  save (exchange) {
    return new Promise((resolve, reject) => {
      Dispatcher.post('exchange/set', { exchange }).then((s) => {
        if (Dispatcher.success(s)) {
          resolve(s)
        } else {
          vm.$notify.error('Save Failed')
          reject(new Error(s.errorCode))
        }
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/exchange/api.js